<template>
  <div class="col-12 pl-0 ml-0 mt-5">
    <v-row class="mb-3">
      <v-col>
        <div class="d-flex mb-2">
          <p class="mb-0 font-weight-light font-weight-bold mr-5">
            디자인 모드 →
            <span class="blue--text">적용할 스킨을 선택</span>해 주세요
          </p>
        </div>
        <v-img class="guide-img" :src="guideDesign1" frameborder="0"></v-img>
      </v-col>
    </v-row>
    <v-row class="pl-0 mb-3">
      <v-col>
        <div class="d-flex mb-2">
          <p class="mb-0 font-weight-light font-weight-bold mr-5">
            좌측 메뉴 아이콘을 클릭 → 상단 메뉴 (+) 아이콘을 클릭 → <span class="blue--text">메뉴명을 입력</span>해 주세요. (ex. 정품
            인증/정품 등록)
          </p>
        </div>
        <v-img class="guide-img" :src="guideDesign2" frameborder="0"></v-img>
      </v-col>
    </v-row>
    <v-row class="pl-0">
      <v-col>
        <div class="d-flex mb-2">
          <p class="mb-0 font-weight-light font-weight-bold mr-5">
            만들어진 메뉴명 옆에 (i) info 아이콘을 클릭 → URL 입력란에 <span class="blue--text">registration</span> 으로 넣어주세요.
          </p>
        </div>
        <v-img class="guide-img" :src="guideDesign3" frameborder="0"></v-img>
      </v-col>
    </v-row>
    <v-row class="pl-0 mb-3">
      <v-col>
        <div class="d-flex mb-2">
          <p class="mb-0 font-weight-light font-weight-bold mr-5">
            만들어진 정품 인증 메뉴에서 ‘위젯 또는 섹션을 추가해주세요’ 클릭 → <span class="blue--text">디자인 요소 ‘코드’를 클릭</span>해
            주세요.
          </p>
        </div>
        <v-img class="guide-img mb-2" :src="guideDesign4" frameborder="0"></v-img>
        <v-img class="guide-img" :src="guideDesign5" frameborder="0"></v-img>
      </v-col>
    </v-row>
    <v-row class="pl-0 mb-3">
      <v-col>
        <div class="d-flex mb-2">
          <p class="mb-0 font-weight-light font-weight-bold mr-5">
            마우스 우측 클릭하여 <span class="blue--text">‘코드 설정’ 클릭</span> → 입력창에 코드를 입력합니다.
          </p>
        </div>
        <v-img class="guide-img mb-2" :src="guideDesign6" frameborder="0"></v-img>
        <v-img class="guide-img" :src="guideDesign7" frameborder="0"></v-img>
      </v-col>
    </v-row>
    <v-row class="pl-0 mb-3">
      <v-col>
        <div class="d-flex mb-2">
          <p class="mb-0 font-weight-light font-weight-bold mr-5">
            <span class="blue--text">아래의 코드를 복사</span>하여 입력창에 <span class="blue--text">붙여넣기 및 저장</span>해 주세요.
          </p>
        </div>
        <!-- 코드 복사 영역 -->
        <div class="code-copy-area" style="margin-bottom:24px; max-width: 1326px;">
          <div style="border:1px solid #ddd;border-radius:8px;background:#fff;overflow:hidden;">
            <div
              style="background:#f9f9f9;border-bottom:1px solid #eee;padding:12px 16px;display:flex;align-items:center;gap:8px; justify-content:end;"
            >
              <button
                type="button"
                @click="copyCode"
                style="background:none;border:none;cursor:pointer;padding:2px;display:flex;align-items:center;"
                aria-label="코드 복사"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#666"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                </svg>
              </button>
              <span @click="copyCode" style="cursor:pointer;font-size:14px;color:#333;font-weight:500;">코드 복사</span>
            </div>
            <div style="position:relative;">
              <textarea
                id="codeCopyTextarea"
                v-model="sourceCopy"
                readonly
                style="width:100%;height:200px;font-size:12px;font-family:'Consolas','Monaco','Courier New',monospace;padding:12px;border:none;resize:none;box-sizing:border-box;background:#fff;line-height:1.4;color:#333;overflow-y:auto;outline:none;"
              ></textarea>
            </div>
          </div>
        </div>
        <v-img class="guide-img" :src="guideDesign8" frameborder="0"></v-img>
      </v-col>
    </v-row>
  </div>
</template>
<style scoped>
ul {
  list-style-type: decimal;
}

ul li {
  font-size: 0.9em;
}
.guide-img {
  margin-top: 0;
  max-width: 1326px;
  border: 1px solid #dadada;
  border-radius: 10px;
}
</style>

<script>
import CommonMixin from "@/mixins/CommonMixin.js";
import store from "../../../store";

export default {
  data() {
    return {
      description: "",
      fileCopy: "registration/",
      sourceCopy: "",
      urlCopy: "https://" + store.state.mallId + ".cafe24.com/registration/",
      guideDesign1: require("../../../assets/authservice/images/imweb_design_1.png"),
      guideDesign2: require("../../../assets/authservice/images/imweb_design_2.png"),
      guideDesign3: require("../../../assets/authservice/images/imweb_design_3.png"),
      guideDesign4: require("../../../assets/authservice/images/imweb_design_4.png"),
      guideDesign5: require("../../../assets/authservice/images/imweb_design_5.png"),
      guideDesign6: require("../../../assets/authservice/images/imweb_design_6.png"),
      guideDesign7: require("../../../assets/authservice/images/imweb_design_7.png"),
      guideDesign8: require("../../../assets/authservice/images/imweb_design_end.png"),
    };
  },
  components: {},
  mixins: [CommonMixin],
  created: function() {
    if (sessionStorage.getItem(`${this.$store.state.mallId}_domain`)) {
      this.urlCopy = "https://" + sessionStorage.getItem(`${this.$store.state.mallId}_domain`) + "/registration/index";
    }
    // registration.html 파일을 fetch로 읽어서 textarea에 동적으로 복사
    fetch("/authservice/etc/userfront/imweb/registration.html")
      .then((res) => res.text())
      .then((text) => {
        this.sourceCopy = text;
      });
  },
  methods: {
    async copyCode() {
      // textarea의 값을 클립보드로 복사
      try {
        await navigator.clipboard.writeText(this.sourceCopy);
        this.alertShow("코드가 복사되었습니다.");
      } catch (err) {
        console.error("복사 실패:", err);
        // fallback 방법으로 대체
      }
    },
  },
};
</script>
